import { render, staticRenderFns } from "./ViewGroupCoverageRow.vue?vue&type=template&id=6d89b316&"
import script from "./ViewGroupCoverageRow.vue?vue&type=script&lang=js&"
export * from "./ViewGroupCoverageRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports